<template>
  <div>
    <div class="text-xl font-black py-2">4. Membership Status</div>

    <div class="pt-2">
      <div class="text-lg font-black py-2">Set up and engagement</div>
      <div>Please tick the relevant boxes for all of the items that the individual is set up for and engaged with.</div>
      <hr class="border-b my-2">
      <div class="flex w-full items-center">
        <div class="py-2 w-1/3">Members Hub Profiles</div>
        <div class="flex justify-start w-2/3 items-center px-8">
          <div class="px-2 w-1/5">Members Hub Profile</div>
          <div class="px-2 w-1/5">Receives Marketing Email(s)</div>
          <div class="px-2 w-1/5">Member of The Guild Facebook Group</div>
          <div class="px-2 w-1/5">Passed Associate Scheme, Sales and / or Lettings</div>
          <div class="px-2 w-1/5">Referral System Champion(s)</div>
        </div>
      </div>
      <div v-for="(email, index) in review.memberStatus" :key="index">
        <review-member-status-component v-model="review.memberStatus[index]" :showMandatory="showMandatory"></review-member-status-component>
      </div>
    </div>

    <div class="pt-4">
      <div class="text-green text-lg cursor-pointer" @click="addMemberStatus">+ Add member staff email address</div>
    </div>

    <hr class="border-b my-8" />
    <!-- Sub section -->
    <div class="my-8 pt-2">
      <div class="mb-4">
        <div class="py-2">
          <div class="flex w-full justify-between">
            <div class="flex-grow py-2"></div>
            <div class="w-1/5 border-l border-r px-4 mr-2 text-center pb-4">Previous</div>
            <div class="w-1/5 px-4 text-center pb-4">Current</div>
          </div>
          <div class="my-4" v-for="(question, index) in form.questions[page][sectionStart]" :key="index">
            <review-question-component v-model="form.questions[page][sectionStart][index]" column-class="w-1/5 flex justify-between" input-class="mb-0" :showMandatory="showMandatory"></review-question-component>
          </div>
        </div>
      </div>
    </div>
    <hr class="border-b my-8" />

  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'
import ReviewMemberStatusComponent from '@/components/AnnualReview/ReviewMemberStatusComponent'

export default {
  components: { ReviewQuestionComponent, ReviewMemberStatusComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value
    }
  },
  methods: {
    addMemberStatus () {
      var newMemberStatus = {
        'id': null,
        'review_id': this.review.id,
        'email': '',
        'members_hub_profile': null,
        'receiving_marketing_emails': null,
        'facebook_group_user': null,
        'passed_associate_scheme': null,
        'active_referrals': null,
        'created_at': null,
        'updated_at': null
      }
      this.review.memberStatus.push(newMemberStatus)
    }
  }
}
</script>
